import { Accordion, AccordionBody, AccordionHeader, AccordionItem,
        Form, FormGroup, Input, Label, Row, Col, FormText, Modal, ModalHeader, ModalBody, Button, FormFeedback, Spinner} from 'reactstrap';
import styles from './AddProduct.module.scss';
import Breadcrumbs from '../../../global/Components/Breadcrumb/Breadcrumb';
import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import TooltipElement from '../../../global/Components/Tooltip/TooltipElement';
import { useToggle } from '../../../global/utils/hooks/useToggle';
import Categories from '../../../global/Components/Categories/Categories';
import { getRequest } from '../../../global/utils/apiCall';
import SelectForm from '../../../global/Components/Items/SelectForm/SelectForm';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import Regions from '../../../global/Components/Regions/Regions';
import { Editor } from 'primereact/editor';
import Upload from '../../../global/Components/Upload/Upload';
import { Toast } from 'primereact/toast';

const CATEGORY_FILTERS = 'api/v1/categories/';
const PRODUCTS_URL = 'api/v1/products/';
const ALL_CATEGORIES = 'api/v1/categories/mega-menu';

export default function AddProduct() {
  const apiPrivate = useApiPrivate();
  const navigate = useNavigate();
  const toast = useRef(null);

  const [open, setOpen] = useState('1');
  const [isCategorySelect, setIsCategorySelect] = useState(false);
  const [selectCategoryId,setSelectCategoryId] = useState();
  const [selectCategoryName,setSelectCategoryName] = useState('');
  const [categoryFilters,setCategoryFiltars] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [productProperties, setProductProperties] = useState([]);
  const [isValid, setIsValid] =useState(false);
  const [country, setCountry] = useState('');
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [isResult, setIsResult] = useState(false);
  const [categorySelected, setCategorySelected] = useState('');


  
  const [productStatus, setProductStatus, onChangeHandlerProductStatus] = useOnChangeHandler('');
  const [productName, setProductName, onChangeHandlerProductName] = useOnChangeHandler('');
  const [productDescription, setProductDescription, onChangeHandlerProductDescription] = useOnChangeHandler('');
  const [productPrice, setProductPrice, onChangeHandlerProductPrice] = useOnChangeHandler('');
  const [productDiscount, setProductDiscount, onChangeHandlerProductDiscount] = useOnChangeHandler('');
  const [image, setImage, onChangeHandlerImage] = useOnChangeHandler();
  const [galleries, setGalleries, onChangeHandlerGalleries] = useOnChangeHandler();
  const [productTags, setProductTags, onChangeHandlerProductTags] = useOnChangeHandler([]);

  const [modal, setModal, toggleModal] = useToggle(false);

    const toggle = (id) => {
      if (open === id) {
        setOpen('');
      } else {
        setOpen(id);
      }
    };

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
    if(typeof(message) == 'string'){
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }
    else {
      toast.current.show(
        message.map((msg) => ({severity:'error', summary: 'Error', detail: msg, life: 5000}) )
      )
    }
  }
    
    const handleCategorySelected = (selected) => {
      setIsResult(false);
      setSelectCategoryId(selected.id);
      setSelectCategoryName(selected.title);
      setCategorySelected(selected);
      setModal(false);
      setIsCategorySelect(true);
      setOpen("2");
    }

    const callCategories = async () => {
      try {
        const response = await getRequest(CATEGORY_FILTERS,{
          params: {
            is_feature:''
        }
      });
        setCategories(response.data.data);
      }
      catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message)
        } 
      }
    }

    const callAllcategories = async () => {
      try {
        const response = await getRequest(ALL_CATEGORIES,{
          params: {
            is_feature:''
        }
      });
      setAllCategories(response.data.data);
      }
      catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
          showError(error?.response?.data?.message)
        } 
      }
    }

    const handleSearchInCategory = (searchText) => {
      setIsResult(true);
      setSelectCategoryName(searchText);

    //   const oneLevelCategory = [];
    //   for (var item of allCategories ) {
    //     oneLevelCategory.push(item);

    //     if (item.hasOwnProperty('children')) {
    //       for (var secondLevel of item.children){
    //         oneLevelCategory.push(secondLevel);

    //         if (secondLevel.hasOwnProperty('children')) {
    //           for (var thirdLevel of secondLevel.children) {
    //             oneLevelCategory.push(thirdLevel);
    //             }
    //           }
    //         }
    //       }
    //   }

    //   const filteredItems = oneLevelCategory.filter((filter) => 
    //     filter.title.toLowerCase().includes(searchText.toLowerCase())
    //   );

    //   const removeParent = filteredItems.filter((item) =>
    //     !item.hasOwnProperty('children')
    // );

    //   setFilteredCategories(removeParent);
    }

    const handleSelectRegions = (selected) => {
      setCountry(selected['country_id']);
      setState(selected['state_id']);
      setCity(selected['city_id']);
    }

    const handleSelectOption = (selectedId, selectOptionId) => {

      if (productProperties.length < 1) {
        setProductProperties([...productProperties,{property_id: selectedId, property_item_id: selectOptionId}]);
        return
      }

      var resualt = productProperties.find((element) => element.property_id === selectedId);

      for (var item of productProperties) {

        if (resualt === undefined){
          setProductProperties([...productProperties,{property_id: selectedId, property_item_id: selectOptionId}]);    
          
        } else {
            setProductProperties(prevState => {
              const newState = prevState.map(resualt => {
                if(resualt.property_id === selectedId){
                  return {...resualt, property_item_id: selectOptionId}
                }
                return resualt;
              });
              return newState;
            })
        }
      }
    }

    const callCategoryFilters = async () => {
      setIsLoading(true);

      try{
        const response = await getRequest(`${CATEGORY_FILTERS}${selectCategoryId}/filters`);
        setIsLoading(false);
        setCategoryFiltars(response.data.data);
      } catch (error) {
          if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
            showError(error?.response?.data?.message)
          } 
          setIsLoading(false);
      }
    }

   
    const handleBlur = (e) => {
      e.preventDefault();
      if (e.target.value === '') {
        e.target.classList.add("is-invalid");
      } else {
        e.target.classList.remove("is-invalid");
      }
    };
    
    const handleFocus = (e) => {
      e.preventDefault();
      e.target.classList.remove("is-invalid");
      setIsValid(false); 
    }

    const renderHeader = () => {
      return (
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
          <button className="ql-underline" aria-label="Underline"></button>
          <select className="ql-align" defaultValue={'left'}>
            <option></option>
            <option value="right"></option>
            <option value="center"></option>
          </select> 
          <button className="ql-list" value="ordered"></button>
          <button className="ql-list" value="bullet"></button>                         
        </span>
      );
  };

  const header = renderHeader();

  const handleImage = (file) => {
    setImage(file);
  }

  const handleImages = (file) => {
    setGalleries(file);
  }

    const addProduct = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      
      const formData = new FormData();

      let tagArray = [];

      formData.append('category_id', selectCategoryId);
      formData.append('product_status', productStatus);
      formData.append('title', productName);
      formData.append('price', productPrice);
      formData.append('discount', productDiscount);
      formData.append('description', productDescription);
      formData.append('country_id', country);
      formData.append('state_id', state);
      formData.append('city_id', city);
      
      
      if(productTags.length > 0) {
        tagArray = productTags.split(',');       

        for (let i = 0 ; i < tagArray.length ; i++ ) {
          formData.append(`tags[${i}]`,tagArray[i]);
        } 
      }

      formData.append('image', image[0]);

      for (let i = 0; i < galleries.length; i++) {
        formData.append(`galleries[${i}]`, galleries[i]);
      }

      for (let i = 0 ; i < productProperties.length ; i++) {
        formData.append(`properties[${i}][property_id]`,productProperties[i].property_id);
        formData.append(`properties[${i}][property_item_id]`,productProperties[i].property_item_id);
      }

      try {
        const response = await apiPrivate.post(PRODUCTS_URL, formData,{
          headers: {
              'content-type': 'multipart/form-data',  
          }})
        setIsLoading(false);
        showSuccess('Your product has been successfully registered and will be displayed after admin approval')
        setTimeout(() => {
          navigate('/dashboard/my-products');
        }, 3000);
      }
      catch(error) {
        if (error?.response?.status === 422) {
          if(error.response.data.errors) {
            const errors = error?.response?.data?.errors;          
            let message = [];
            Object.keys(errors).forEach((field) => {
              message.push(`${field}: ${errors[field]}`);
            });
            showError(message)
          } else {
            showError(error?.response?.data?.message)
          }

          setIsLoading(false);
        }
      }
      finally{
        setIsLoading(false);
      }
    }

    useEffect(() => {
      callCategories();
      callAllcategories();
    },[]);

    useEffect(() => {
      callCategoryFilters();
    },[selectCategoryId]); 

    useEffect(() => {
      if (Object.keys(categories).length > 0) {
        setFilteredCategories(categories);
      }
    },[categories]);

    useEffect(() => {
      if(!selectCategoryName) {
        setIsResult(false);
      }
    },[selectCategoryName]);


  return (
    <>
    {/* <div className={`bg-white lgtBackground`}> */}
      {/* <div className={`${styles.userWrapper} p-4`}> */}
        <Modal isOpen={modal} toggle={toggleModal} size='lg'>
          <ModalHeader toggle={toggleModal}>
            Select category
          </ModalHeader>
          <ModalBody>
            <Categories handleCategorySelected={handleCategorySelected} />
          </ModalBody>
        </Modal>

        <Breadcrumbs />
        <Toast ref={toast} position="top-center" />

        <Accordion  open={open} toggle={toggle} className='mb-3'>
          <AccordionItem>
            <AccordionHeader targetId="1">
              <i className='bi bi-card-heading me-2 big text-primary'></i>
              <span className='fw-bold'>
                Category selection
              </span>
            </AccordionHeader>
            <AccordionBody accordionId="1">
              <Form id='addForm'>
                <Row>
                  <Col sm={12} md={6}> 
                      <div className='position-relative'>
                        <FormGroup floating>
                            <Input
                              id="search-category"
                              name="category_id"
                              value={selectCategoryName}
                              // onChange={(e) => handleSearchInCategory(e.target.value)}
                              onClick={toggleModal}
                              placeholder="Search"
                              
                              type="text"
                            />
                            {/* <span className={`${styles.infoIcon}`}
                                rel="noreferrer"
                                id="product-category">
                              <i id='search-category-desc' className={`bi bi-info-circle`}></i>
                            </span> */}
                            {/* <TooltipElement target={'search-category-desc'}>
                              search in Categories
                            </TooltipElement> */}
                            <Label for="search-category">
                              Search in categories
                            </Label>
                          </FormGroup>   
                          {/* <div className={`position-absolute bg-white ${styles.searchResult} ${isResult ? 'd-block' : 'd-none'}`}>
                            <ul className={`list-unstyled mb-0`}>
                            {
                            filteredCategories.length > 0 
                              ? filteredCategories.map((category) => (
                                <li 
                                  id={category.id} 
                                  key={`cat-${category.id}`}  
                                  className={`py-1`}
                                  onClick={() => handleCategorySelected(category)}
                                  >
                                  {category.title}
                                </li>
                              ))
                              : <p className="fw-bold py-4 mb-0">No Category to display</p>

                            }
                            </ul>
                          </div> */}
                      </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={8}>
                    <div className='mb-3'>
                      <Link onClick={toggleModal} className={`text-decoration-none fw-semibold`}>
                        See all the categories
                      </Link>
                    </div>
                  </Col>
                </Row>
              </Form>
            </AccordionBody>
          </AccordionItem>
         {
          isCategorySelect &&
            <>
              <AccordionItem>
                <AccordionHeader targetId="2">
                  <i className='bi bi-card-list me-2 big text-primary'></i>
                  <span className='fw-bold'>
                    General Info
                  </span>
                </AccordionHeader>
                <AccordionBody accordionId="2">
                  <Form>
                    <Row>
                      <Col>
                      <div className='mb-3 d-flex flex-wrap'>
                        <FormText className='mt-0 align-content-center'>
                          {categorySelected.title} {'('}
                        </FormText>
                        <div className='me-2'>
                          <FormText className='me-1'>
                            Listing Price:
                          </FormText>
                          <FormText>
                            {
                              categorySelected.listing_price == 0
                                ? 'free'
                                : categorySelected.listing_price
                            },
                          </FormText>
                        </div>
                        <div>
                          <FormText className='me-1'>
                            Sell Commission:
                          </FormText>
                          <FormText>
                            {
                              categorySelected.sell_commission == 0
                                ? 'free'
                                : categorySelected.sell_commission
                            }{')'}
                          </FormText>
                        </div>
                      </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={6}>
                        <FormGroup floating>
                            <Input
                              id="product-name"
                              name="title"
                              placeholder="Product name"
                              type="text"
                              value={productName}
                              onChange={onChangeHandlerProductName}
                              required
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              invalid={isValid}
                            />
                            <FormFeedback tooltip>
                              The product name must be at least 3 letters long
                            </FormFeedback>
                            <span className={`${styles.infoIcon}`}
                                  rel="noreferrer"
                                  id="product-name">
                              <i className={`bi bi-info-circle`}  id='product-name-desc'></i>
                            </span>
                            <TooltipElement target={'product-name-desc'}>
                              Brand and product name
                            </TooltipElement>
                            <Label for="product-name">
                              Product name
                              <span className='text-danger'>*</span>
                            </Label>
                          </FormGroup>    
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className='mb-3'>
                          <Label className='d-block mb-2 fw-semibold'>
                            Status:
                          <span className='text-danger'>*</span></Label>
                          <Input
                            type="radio"
                            name="product_status"
                            value="new"
                            className={`invisible ${styles.removeRadio}`}
                            id="new"
                            checked={productStatus === "new"}
                            onChange={onChangeHandlerProductStatus}
                            required
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            invalid={isValid}
                          />
                          <FormFeedback tooltip>
                            This field is required                            
                          </FormFeedback>
                          <Label 
                              htmlFor="new"
                              className={`outlinBtn ms-2 p-1 ${productStatus == "new" ? 'active' : ''}`}
                              >
                                New
                              </Label>

                          <Input
                            type="radio"
                            name="product_status"
                            value="old"
                            className={`invisible ${styles.removeRadio}`}
                            id="old"
                            checked={productStatus === "old"}
                            onChange={onChangeHandlerProductStatus}
                          />
                          <Label 
                              htmlFor="old"
                              className={`outlinBtn ms-2 p-1 ${productStatus == "old" ? 'active' : ''}`}
                              >
                                Old
                              </Label>
                          <Input
                            type="radio"
                            name="product_status"
                            value="defective"
                            className={`invisible ${styles.removeRadio}`}
                            id="defective"
                            checked={productStatus === "defective"}
                            onChange={onChangeHandlerProductStatus}
                          />
                          <Label 
                              htmlFor="defective"
                              className={`outlinBtn ms-2 p-1 ${productStatus == "defective" ? 'active' : ''}`}
                              >
                                Defective
                              </Label>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <FormGroup floating>
                          <Input
                            id="product-price"
                            name="price"
                            placeholder="Product price"
                            type="number"
                            value={productPrice}
                            onChange={onChangeHandlerProductPrice}
                            required
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            invalid={isValid}
                          />
                          <FormFeedback tooltip>
                            This field is required                            
                          </FormFeedback>
                          <span className={`${styles.infoIcon}`}
                                rel="noreferrer"
                                id="product-price">
                            <i className={`bi bi-info-circle`}  id='product-price-desc'></i>
                          </span>
                          <TooltipElement target={'product-price-desc'}>
                            Product price
                          </TooltipElement>
                          <Label for="product-price">
                            Price
                            <span className='text-danger'>*</span>
                          </Label>
                        </FormGroup>  
                      </Col>
                      <Col md={4}>
                        <FormGroup floating>
                          <Input
                            id="product-discount"
                            name="discount"
                            placeholder="Product discount"
                            type="number"
                            value={productDiscount}
                            onChange={onChangeHandlerProductDiscount}
                          />
                          <span className={`${styles.infoIcon}`}
                                rel="noreferrer"
                                id="product-discount">
                            <i className={`bi bi-info-circle`}  id='product-discount-desc'></i>
                          </span>
                          <TooltipElement target={'product-discount-desc'}>
                            Discount percent
                          </TooltipElement>
                          <Label for="product-discount">
                            Discount
                          </Label>
                        </FormGroup>  
                      </Col>
                    </Row>
                    <Row>
                    <Col md={6}>
                        <FormGroup floating>
                          <Input
                            id="product-tags"
                            name="tags"
                            placeholder="Product tags"
                            type="text"
                            value={productTags}
                            onChange={onChangeHandlerProductTags}
                            required
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            invalid={isValid}
                          />
                          <FormFeedback tooltip>
                            This field is required                            
                          </FormFeedback>
                          <span className={`${styles.infoIcon}`}
                                rel="noreferrer"
                                id="product-tags">
                            <i className={`bi bi-info-circle`}  id='product-tags-desc'></i>
                          </span>
                          <TooltipElement target={'product-tags-desc'}>
                            Separate product Tags with Commas symbol
                          </TooltipElement>
                          <Label for="product-tags">
                            Tags
                            <span className='text-danger'>*</span>
                          </Label>
                        </FormGroup>  
                      </Col>
                    </Row>
                    <FormGroup>
                    <Row>
                        <Regions col={4} handleSelectRegions={handleSelectRegions} />
                    </Row>
                  </FormGroup>
                  </Form>
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="3">
                  <i className='bi bi-image me-2 big text-primary'></i>
                  <span className='fw-bold'>
                    Product Image
                  </span>
                </AccordionHeader>
                <AccordionBody accordionId="3">
                  <Form>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label className='fw-semibold' for="uploadImage">
                            Product Image
                            <span className='text-danger'>*</span>
                          </Label>
                            <Upload 
                              id="uploadImage"
                              name="image"
                              accept="image/jpeg, image/png, image/jpg, image/jpe"
                              required={true}
                              handleImages={handleImage}
                              multiple={false} 
                              />
                            <FormText>
                              Accept Format: .jpeg, .jpg, jpe, .png
                            </FormText>
                          <FormFeedback>
                            This field is required                            
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label className='fw-semibold' for="uploadImage">
                            Galleries
                            <span className='text-danger'>*</span>
                          </Label>
                          <Upload 
                            id="uploadImages"
                            name="galleries"
                            accept="image/jpeg, image/png, image/jpg, image/jpe"
                            required={true}
                            handleImages={handleImages}
                            multiple={true} 
                            isUploadButton={false}
                            />
                            <FormText>
                              Accept Format: .jpeg, .jpg, jpe, .png
                            </FormText>
                          <FormFeedback>
                            This field is required                            
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="4">
                  <i className='bi bi-card-checklist me-2 big text-primary'></i>
                  <span className='fw-bold'>
                    Product Properties
                  </span>
                </AccordionHeader>
                <AccordionBody accordionId="4">
                  <FormGroup>
                    <Row>
                    {
                      categoryFilters.map((filter) => (
                        <Col md={3} className='mb-3' key={filter.id}>
                          <div>
                            <Label className='fw-semibold'>
                              {filter.title}
                              {
                                filter.is_force 
                                ? <span className='text-danger'>*</span>
                                : ''
                              }
                            </Label>
                          </div>
                          <div>
                            <SelectForm 
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              invalid={isValid} 
                              handleSelectOption={handleSelectOption} 
                              data={filter}/>
                          </div>
                        </Col>
                      ))
                    }
                    </Row>
                  </FormGroup>
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="5">
                  <i className='bi bi-card-text me-2 big text-primary'></i>
                  <span className='fw-bold'>
                    More Details
                  </span>
                </AccordionHeader>
                <AccordionBody accordionId="5">
                  <Form>
                    <FormGroup>
                      <Editor 
                        id='more-details' 
                        name='description' 
                        value={productDescription} 
                        onTextChange={(e) => setProductDescription(e.htmlValue)} 
                        style={{ height: '320px', color: '#212529',size: '16px' }} 
                        headerTemplate={header} />
                      <FormText>
                        Avoid entering contact information such as: phone, email and address.
                      </FormText>
                    </FormGroup>
                  </Form>
                </AccordionBody>
              </AccordionItem>
            </>
         }
        </Accordion>
        {
          isCategorySelect &&
            <Row>
              <Col>
                <Button onClick={(e) => addProduct(e)}
                        disabled={!productName || !selectCategoryId || !productStatus || !productPrice || !image || !galleries || isLoading || !(productTags.length > 0) && true}
                        >
                  {
                    isLoading 
                      ? (
                        <>
                          <Spinner size="sm">
                            Loading...
                          </Spinner>
                          <span>
                            {' '}Adding to List
                          </span>
                        </>
                      )
                      : 'Add to List'
                  }
                </Button>
                {
                  !productName || !selectCategoryId || !productStatus || !productPrice || !image || !galleries || !(productTags.length > 0) 
                  ? (
                    <FormText className='ms-2'>
                      Please fill in the required 
                      <span className='text-danger'> * </span>
                      fields
                    </FormText>
                      )
                  : ''
                }
              </Col>
            </Row>
        }
    </>
  )
}
